import styled, { createGlobalStyle, css } from 'styled-components';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
// import 'react-morphing-modal/dist/ReactMorphingModal.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-vertical-timeline-component/style.min.css';
import 'react-modal-video/css/modal-video.min.css';

import PerfectScrollbar from 'react-perfect-scrollbar';
import AvatarBase from 'react-avatar';

import { lighten, darken, desaturate, transparentize } from 'polished';

import { device } from './device';

export default createGlobalStyle`
  /* @import url('https://fonts.googleapis.com/css?family=Poppins:200,300,400,600,700,800');
  @import url('https://use.fontawesome.com/releases/v5.0.6/css/all.css'); */
  /* @import 'node_modules/react-modal-video/scss/modal-video.scss'; */

 *{
    margin: 0;
    padding: 0;
    outline: 0;
    font-family: 'Poppins', sans-serif;



  }

  *, :after, :before {
    box-sizing: border-box;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
  }


  p, strong {
    font-size: 0.95rem;
  }
  a {
    text-decoration: none
  }

  ul {
    /* list-style: none */
  }
  h1,h2,h3,h4,h5,h6,p,span,strong{
    color: ${props => props.theme.fontColor};
    caret-color:transparent;
  }

  h1,h2,h3,h4,h5 {
    display:block;
    font-family: inherit;
    font-weight: 400;
  }

  h1{
    font-size: 2.0625rem;
  }

  h2{
    font-size: 1.6875rem;
  }

  h3{
    font-size: 1.4375rem;
  }

  h4{
    font-size: 1.0625rem
  }

  h5{
    font-size: .8125rem;
  }

  h6{
    font-size: .75rem;
    text-transform: uppercase;
    font-weight: 600;
  }

  span{
    font-size: 0.75rem;
  }

  label{
    font-size: 0.85rem;
  }

  button {
    cursor: pointer;
  }

  // force skeleton theme provider 100%
  #root{
    >div{
      height: 100%;
    }
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    font: .835rem 'Poppins', sans-serif !important;
    -webkit-transition: color 9999s ease-out, background-color 9999s ease-out !important;
    -webkit-transition-delay: 9999s !important;
  }
/* REMOVE SPAN DO LABEL */
.react-select2__multi-value__label{
  span{
    display:none;
  }
}
/* DIALOG CSS */
.swal2-height-auto{
  background: ${props => props.theme.background};
}

.swal2-shown{
  >div{

    background: ${props => props.theme.cardBackgroud};
  }
}

.swal2-icon{

  span {
    font-size: inherit;
  }
}

.swal2-success-circular-line-left, .swal2-success-circular-line-right, .swal2-success-fix{
  background-color: transparent !important;
}

.swal2-icon.swal2-info {
  border-color: ${props => props.theme.button.primary.out} !important;
  color: ${props => props.theme.button.primary.out} !important;
}

.swal2-icon.swal2-question{
  border-color: ${props => props.theme.button.primary.out} !important;
  color: ${props => props.theme.button.primary.out} !important;
}

.swal2-popup {
    width:fit-content !important;
    padding: 0 !important;
  }

.swal2-content{
  width: 40em;
  min-width: 20em;
  color:  ${props => props.theme.fontColor} !important;
  padding: 0 1.65rem 1.65rem 1.65rem  !important;
  max-width: 50em;
  input{
    font: .875rem 'Poppins', sans-serif !important;
  width: 90%;
  padding: 0 1rem !important;
  border-radius: 4px;
  height: 38px;
  transition: border 0.3s ease;
  color: ${props => props.theme.fontColor};
  background: ${props =>
    props.theme.name === 'dark'
      ? lighten(0.05, props.theme.cardBackgroud)
      : darken(0.01, props.theme.cardBackgroud)};

  border: 1px solid
    ${props =>
      props.theme.name === 'dark'
        ? lighten(0.1, props.theme.cardBackgroud)
        : darken(0.15, props.theme.cardBackgroud)};
  ${({ error }) =>
    error === 'true' &&
    css`
      border-color: ${props => props.theme.error};
    `}
  &:focus {
    border-color: ${props => desaturate(0.5, props.theme.button.primary.in)};
  }
  }

  >div{
    *{
      color:  ${props => props.theme.fontColor};
    }
    img{

      border-radius: 5px;
    }
    div{
      display: flex;
      flex-direction: row;
      /* padding: 0 1.65rem 0 1.65rem !important; */
      ul {
        width: 100%;
        display: flex;
        flex-direction: column;

          li {
            display: flex;

            font-size: 1.05rem !important;
            font-weight: 300;
            display: flex;
            margin-top: 5px;
            align-items: center;
            justify-content: space-between;

            &:first-of-type {
              margin-top: 0;
            }

      strong {
        display: flex;
        align-items: center;
        margin: 0 10px;
        font-weight: 400;

        img{
           margin-left: 5px;
        }
      }
    }
  }
  }
  }


}

.swal2-actions {
  padding: 0 !important;
  margin:0.65rem 0 0.65rem 0  !important;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 0.875rem !important;
    border: none;
    overflow: hidden;
    height: 40px;
    line-height: 1.35em;
    margin: 4px 0;
    background-color: ${props => props.theme.button.primary.out} !important;

    &:focus{
      box-shadow: none !important;
    }
  }
}

.swal2-confirm,.swal2-cancel{
        margin: 0 5px !important;
}

.swal2-confirm{

}

.swal2-cancel.swal2-styled{
  background-color: ${props => props.theme.button.default.out} !important;
}

.swal2-loading{
  padding: 2rem !important;
}

.swal2-validation-message{
  background: ${props => props.theme.cardBackgroud} !important;
  /* display: flex; */
  justify-content: flex-start !important;
  padding: 0 1.25rem !important;
  &::after{
    content: 'Campo obrigatório' !important;
    color: ${props => props.theme.error}
  }
}

.jodit-toolbar-button__button{
  span {
    color:black;
  }
}
.jodit-ui-button__text{
    color:black;
}
.jodit__preview-box.jodit-context{
    span,
    li,
    ul,
    p {
      /* font-family: initial !important; */
      font-size: initial;
      color: black;
    }
  ul,
  ol {
    padding-left: 20px;
    /* list-style: unset; */
  }
}
`;

export const Scroll = styled(PerfectScrollbar)`
  height: ${props =>
    props.height ? props.height : 'calc(100vh - 220px)'} !important;
  width: ${props => (props.width ? props.width : '100%')};
  padding: ${props => (props.padding ? props.padding : '0 15px')};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: ${props => (props.margin ? props.margin : '10px 0 0 0')};
  caret-color: transparent;

  thead {
    tr {
      th {
        text-align: left;
        /* padding: 10px 5px 10px 0px; */
        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 400 !important;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 0.1px solid
        ${props => transparentize(0.7, props.theme.fontColor)};
      &:last-of-type {
        border-bottom: none;
      }
      td {
        // border: 3px solid red;
        // justify-content:center
        padding: 10px 0px;

        font-size: 1.0625rem;
        color: ${props => props.theme.fontColor};
        /* color: 'red'; */

        button {
          margin: 0;
        }
      }

      &:hover {
        transition: all 0.25s ease;
        ${props =>
          props.theme.name === 'dark'
            ? css`
                background-color: ${props =>
                  lighten(0.03, props.theme.cardBackgroud)};
              `
            : css`
                background-color: ${props =>
                  darken(0.03, props.theme.cardBackgroud)};
              `}
      }
    }
  }

  /* CLOSED CAPTION */
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #666;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #ccc;
  }
`;

export const Align = styled.div`
  justify-content: ${({ align }) =>
    align === 'right'
      ? 'flex-end'
      : align === 'center'
      ? 'center'
      : 'flex-start'};

  display: flex;
  color: ${props => props.theme.fontColor};
  font-size: 1.0625rem;
  font-weight: 400 !important;
`;
export const TdFlag = styled.td`
  width: ${props => props.size + 'rem'};
  font-size: 1.0625rem;
  color: ${props => props.theme.fontColor};
  padding: 0 !important;

  div {
    margin-right: 5px;
    width: 10px;
    height: 40px;

    ${props =>
      props.$isGe && !props.isIndisponivel
        ? css`
            background: ${props.theme.button.warn.in};
          `
        : !props.$isGe && props.isIndisponivel
        ? css`
            background: ${props.theme.button.danger.out};
          `
        : props.$isGe && props.isIndisponivel
        ? css`
            background-image: linear-gradient(
              ${props.theme.button.danger.out},
              ${props.theme.button.warn.in}
            );
          `
        : ``}

background-color: ${props => props.theme.flag[props.type]};
    ${props => (!props.hasMidia || props.avaliadaeng ? 'opacity: 0.3' : '')}
  }
`;

export const ThumbnailContainer = styled.div`
  position: relative;
  min-width: 100px;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: auto;
    max-width: 200px;
    border-radius: 5px !important;
    cursor: ${props => (props.inUpload ? 'default' : 'pointer')};
    transition: all 0.1s ease-in-out;
    filter: ${props =>
      props.inUpload ? 'blur(1px) grayscale(100%)' : 'blur(0px)'};
  }

  svg.icon_play {
    position: absolute !important;
    transform: translateY(30px);
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s;
    border: #fff solid 1px;
    color: #fff;
    padding: 5px 4px 5px 5px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }

  &:hover {
    img {
      opacity: 1;
      transform: scale(1.1);
      filter: blur(0.6px);
    }
    svg.icon_play {
      opacity: 1;
      transform: translateY(0) scale(2);
    }
  }
`;

export const Td = styled.td`
  padding: 10px 10px 10px 0px !important;
  width: ${props => props.size + 'rem'};
  font-size: 1.0625rem;
  color:${props =>
    props.disabled
      ? props.theme.secondaryFontColor
      : props.theme.fontColor} !important;
  text-decoration: ${props => (props.disabled ? 'line-through' : 'none')};

  ${props =>
    !!props.hide &&
    css`
      @media ${device[props.hide]} {
        display: none;
      }
    `}

  strong {
    /* opacity:  ${props => (props.disabled ? 1 : 0.2)};
  color: ${props => (props.disabled ? 'red' : props.theme.fontColor)}; */
  color:${props =>
    props.disabled
      ? props.theme.secondaryFontColor
      : props.theme.fontColor} !important;
    margin-left: 5px;
    font-size: 0.88rem;
    font-weight: normal;
    font-style: italic;

    &:before {
      content: '-';
      margin-right: 10px;
    }
  }
//Comentado estilização de button dentro de tabelas
// Sem margin, eles se agrupam na direita da tabela e os botões na tela de
//aprovacao ficam melhor centralizados
  /* button {
    margin: 0 auto !important;
  } */
`;

export const Th = styled.th`
  ${props =>
    !!props.hide &&
    css`
      @media ${device[props.hide]} {
        display: none;
      }
    `}
`;
